import { css } from '@emotion/react';
import { alpha } from '@mui/material/styles';

// Used when a theme defines no continue-button colour, so the card still tints
// instead of throwing on `alpha(undefined)`.
const DEFAULT_TINT = '#0da587';

// The row separator on the confirmation card, from the demo.
const DIVIDER_COLOUR = 'rgba(237, 237, 237, 1)';

const makeSolarSummaryCardStyles = ({
  theme,
  inline = false,
  dividers = false,
}) => {
  const { palette } = theme.mvf;
  // The theme's green (aurora's CTA green), so the summary tracks the theme
  // rather than a hardcoded colour.
  const green = palette.component?.continueButtonColor ?? DEFAULT_TINT;

  return {
    summary: css({
      display: 'flex',
      flexDirection: 'column',
      gap: inline ? 0 : 12,
      backgroundColor: alpha(green, 0.1),
      borderRadius: 8,
      padding: '12px 16px',
      margin: '16px 0',
      textAlign: 'left',
    }),
    heading: css({
      fontSize: '0.875rem',
      fontWeight: 600,
      color: palette.text.primaryTextColor,
    }),
    summaryText: css(
      inline
        ? {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            gap: 16,
            padding: '10px 0',
            textAlign: 'left',
            ...(dividers && {
              '&:not(:last-of-type)': {
                borderBottom: `1px solid ${DIVIDER_COLOUR}`,
              },
            }),
          }
        : {
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
          }
    ),
    summaryLabel: css({
      fontSize: inline ? '0.875rem' : '0.6875rem',
      color: palette.text.secondaryTextColor,
      flexShrink: 0,
    }),
    summaryValue: css({
      fontSize: '0.875rem',
      fontWeight: inline ? 700 : 500,
      color: palette.text.primaryTextColor,
      ...(inline && {
        textAlign: 'right',
        minWidth: 0,
        overflowWrap: 'anywhere',
      }),
    }),
  };
};

export default makeSolarSummaryCardStyles;
